"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTextGetter = void 0;
const defaultTextGetter = (option) => {
    if (option && typeof option['text'] === 'string') {
        return option['text'];
    }
    console.warn("Text not found in 'data' or 'selected' props. Please describe the prop 'textGetter' in 'List'.");
    return '';
};
exports.defaultTextGetter = defaultTextGetter;
//# sourceMappingURL=defaultTextGetter.js.map